export type UiEventName = `${string}.${string}`;
export type UiEventHandler = (detail: unknown) => void;

export type UiEventBus = {
  readonly on: (name: UiEventName, handler: UiEventHandler) => () => void;
  readonly emit: (name: UiEventName, detail?: unknown) => boolean;
};

export function createUiEventBus(): UiEventBus {
  const handlers = new Map<UiEventName, Set<UiEventHandler>>();
  return {
    on: (name, handler) => {
      const set = handlers.get(name) ?? new Set<UiEventHandler>();
      set.add(handler);
      handlers.set(name, set);
      return () => {
        set.delete(handler);
        if (set.size === 0) handlers.delete(name);
      };
    },
    emit: (name, detail) => {
      const set = handlers.get(name);
      if (!set || set.size === 0) return false;
      [...set].forEach((handler) => {
        try {
          handler(detail);
        } catch (error) {
          console.error(`ui event ${name} handler failed`, error);
        }
      });
      return true;
    }
  };
}
